"use client"

import { WandSparkles } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WandSparklesIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WandSparklesIcon = component(Icon)({ as: WandSparkles })
